import { Box, Link, Heading } from 'theme-ui'
import KnowledgeBase from './knowledgeBase'

const ExploreKnowledgeBase = () => {
  return (
    <Box>
      <Heading as="h3" sx={{ fontSize: [4], lineHeight: 'body', my: [2, null, 3] }}>
        Mere om Polis-modellen fra The Computational Democracy Project
      </Heading>
      <Box sx={{ mb: [4, null, 5], maxWidth: '35em' }}>
        {/* prettier-ignore */}
        <Box style={{ mb: [5, null, 6] }}>
          Besøg den{' '}
          {/* prettier-ignore */}
          <Link
            target="_blank"
            href="https://compdemocracy.org/knowledge-base">
              generelle vidensbase,
          </Link>{' '}
          eller læs mere om...
        </Box>
        <KnowledgeBase url="https://compdemocracy.org/Welcome" e="👋" txt="Velkomst guide" />
        <KnowledgeBase url="https://compdemocracy.org/Quickstart" e="🏎" txt="Quickstart" />
        <KnowledgeBase url="https://compdemocracy.org/Usage" e="🔩" txt="Sådan bruges det" />
        {/* prettier-ignore */}
        <KnowledgeBase
          url="https://compdemocracy.org/FAQ"
          e="📖"
          txt="FAQ"
        />
        <KnowledgeBase url="https://compdemocracy.org/Case-studies" e="⚗️" txt="Case studier" />
        <KnowledgeBase url="https://compdemocracy.org/algorithms" e="👾" txt="Algoritmer" />
        <KnowledgeBase
          url="https://compdemocracy.org/Moderation"
          e="👹"
          txt="Moderation - bedste praksis"
        />
        <KnowledgeBase url="https://compdemocracy.org/Media-coverage" e="🗞" txt="Presse - original Polis" />
      </Box>
    </Box>
  )
}

export default ExploreKnowledgeBase
